<template>
    <div class="container-fluid content-page-wrapper">
        <div class="row py-5">
            <div class="col-sm-12 col-md-6 m-auto">
                <h1>{{ $t('Edit account') }}</h1>
                <edit-account-form></edit-account-form>
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';

export default {

    computed: {

        ...mapGetters({
            authenticated: 'auth/authenticated',
            user: 'auth/user',
            permissions: 'auth/permissions'
        }),

    },

}

</script>
